module.exports = __webpack_public_path__ + "static/media/use-jimmy.bc6879ac.png";